<div id="masterheader" class="header" style="text-align: center">
    <a (click)="header_trg('home')">
        <img class="iconL" src="../assets/img/octa/octa-light-30.png" style="opacity: 1" />
    </a>

    
    
    <a (click)="header_trg('sidebar')" id="trg_nav" class="iconR">
        <fa-icon [icon]="FAIcon"></fa-icon>
    </a>
</div>	